
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useImperativeHandle } from 'react';
import { Row, Col } from "antd";
import { Button, Typography, Box, TextField } from "@mui/material";
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { useDispatch, useSelector } from "react-redux";
import usePrevious from "../../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../../helpers/validation";
import crudActions from "../../../../../CRUD/redux/actions";
import CustomAlert from "../../../../../Shared/components/CustomAlert";
import { toast } from 'react-toastify';
import { AESEncrypt } from "../../../../../../helpers/Crypto";
import { NavLink } from "react-router-dom";


export const TaxForm = React.forwardRef((props, ref) => {
    const { classes, clsx, type, countryDetails, customObject, taxId, history } = props;
    const { createDetails, createError, editDetails, editError, createData, createLoader } = useSelector(state => state.crudReducer);
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [taxForm, setTaxForm] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const dispatch = useDispatch();


    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e
            })
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value
            })
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyCountry = emptyValidation('Country', form?.countryId, 'dropDown');
        let emptyName = emptyValidation('Name', form?.name);
        setError({});
        if (emptyCountry.isValid && emptyName.isValid) {
            delete form.country;
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));
            dispatch({
                type: taxId === 0 ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: "country-taxes",
                id: taxId,
                title: "Country Taxes",
                details: data
            });
            setTaxForm(true);
        } else {
            setError({
                countryId: emptyCountry.errors,
                name: emptyName.errors
            });
        }

    }

    useImperativeHandle(ref, () => ({
        onEdit(data) {
            setForm(data);
        }
    }))



    useEffect(() => {
        if (taxForm) {

            if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
                toast.dismiss(); setTaxForm(false);
                toast(`"${createData.name}" has been added successfully`);
                history.push(`/younote-admin/setup/tax-setup/${AESEncrypt(createData.id)}/view`, `${type}`);
            } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
                setTaxForm(false);
                let text = createError.error.message;
                setError({
                    "common": text
                })
            }
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (taxForm) {
            if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
                toast.dismiss();
                setTaxForm(false);
                toast(`"${form.name}" has been updated successfully`);
                history.push(`/younote-admin/setup/tax-setup/${AESEncrypt(form.id)}/view`, `${type}`);
            } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
                setTaxForm(false);
                let text = createError.error.message;
                setError({
                    "common": text
                })
            }
        }
    }, [editDetails, editError]);

    return (
        <Box className={clsx(classes.removeUnderline)}
            component="form"
            autoComplete="off"
            onSubmit={(e) => handleSubmit(e)}>
            <Row gutter={100}>
                {
                    error?.common && <Col span={24}><CustomAlert error={error?.common} customClass={clsx(classes.uploadError, classes.marginBottom10)} /></Col>
                }
                <Col span={12}><Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.bold)}
                >General</Typography>
                </Col>
                <Col span={12} className={classes.textAlignRight}>
                    {
                        type === 'view' ? <NavLink
                            to={`/younote-admin/setup/tax-setup/${AESEncrypt(taxId)}/edit`}
                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                            Edit
                        </NavLink> : <Button
                            type='submit'
                            color='primary'
                            variant="contained"
                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}>
                            Save
                        </Button>
                    }
                </Col>
                <Col span={6}>
                    {
                        type === 'view' ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Country</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.country?.name || '---'}</Typography>
                        </> : <AutoCompleteComponent
                            name={["Country"]}
                            heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                            details={countryDetails}
                            parentValue={customObject(countryDetails, form?.countryId)}
                            onChange={(data) => changeHandler(data.id, 'countryId')}
                            position={"bottom"}
                            parentError={error?.countryId}
                        />
                    }
                </Col>
                <Col span={6}>
                    {
                        type === 'view' ? <>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Name</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.name || '---'}</Typography>
                        </> : <TextField autoComplete='one-time-code'
                            label='Tax Name'
                            fullWidth
                            name={"name"}
                            error={error?.name && true}
                            helperText={error?.name}
                            variant={'standard'}
                            value={form?.name}
                            InputProps={{
                                classes: {
                                    input: classes.textFieldColor
                                }
                            }}
                            InputLabelProps={{
                                className: classes.textFieldLableColorCustom, shrink: form.name
                            }}
                            onChange={(e) => changeHandler(e)}
                        />
                    }
                </Col>
            </Row>
        </Box>
    )
})